module.exports = __webpack_public_path__ + "static/img/ruzhu-02.e6bfe1e3.png";